import { useState } from "react";
import { Calendar, RefreshCw } from "lucide-react";

const PRESETS = [
  { key: "7", label: "7D", days: 7 },
  { key: "30", label: "30D", days: 30 },
  { key: "90", label: "90D", days: 90 },
  { key: "365", label: "1Y", days: 365 },
  { key: "ytd", label: "YTD" },
  { key: "all", label: "All" },
  { key: "custom", label: "Custom" },
];

function isoDate(d) {
  return d.toISOString().slice(0, 10);
}

export function rangeFromPreset(preset, from, to) {
  const now = new Date();
  if (preset === "all") return { date_from: undefined, date_to: undefined };
  if (preset === "custom") {
    return { date_from: from || undefined, date_to: to || undefined };
  }
  if (preset === "ytd") {
    return { date_from: `${now.getUTCFullYear()}-01-01`, date_to: isoDate(now) };
  }
  const days = Number(preset);
  if (!Number.isNaN(days)) {
    const d = new Date(now);
    d.setUTCDate(d.getUTCDate() - days);
    return { date_from: isoDate(d), date_to: isoDate(now) };
  }
  return {};
}

export default function DateRangePicker({ preset, setPreset, from, setFrom, to, setTo, onRefresh, testidPrefix = "" }) {
  return (
    <div className="ft-card p-4 sm:p-5 flex items-center flex-wrap gap-3" data-testid={`${testidPrefix}date-range-panel`}>
      <Calendar size={16} className="text-[#FF5A1F]" />
      <span className="ft-overline">DATE RANGE</span>
      <div className="flex gap-1 flex-wrap">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            onClick={() => setPreset(p.key)}
            className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wider border transition-colors duration-200 ${
              preset === p.key
                ? "bg-[#FF5A1F] text-black border-[#FF5A1F]"
                : "border-[#262626] text-[#A3A3A3] hover:text-white hover:border-[#FF5A1F]"
            }`}
            data-testid={`${testidPrefix}preset-${p.key}`}
          >
            {p.label}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div className="flex gap-2 items-center flex-wrap">
          <input
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="bg-[#0A0A0A] border border-[#262626] px-3 py-1.5 font-mono text-white text-xs focus:outline-none focus:border-[#FF5A1F]"
            data-testid={`${testidPrefix}range-from`}
          />
          <span className="text-[#737373]">→</span>
          <input
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="bg-[#0A0A0A] border border-[#262626] px-3 py-1.5 font-mono text-white text-xs focus:outline-none focus:border-[#FF5A1F]"
            data-testid={`${testidPrefix}range-to`}
          />
        </div>
      )}
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="ml-auto border border-[#262626] hover:border-[#FF5A1F] text-[#A3A3A3] hover:text-white px-3 py-1.5 inline-flex items-center gap-2 text-xs transition-colors"
          data-testid={`${testidPrefix}refresh-btn`}
        >
          <RefreshCw size={14} /> Refresh
        </button>
      )}
    </div>
  );
}

export function useDateRange(initialPreset = "30") {
  const [preset, setPreset] = useState(initialPreset);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const params = rangeFromPreset(preset, from, to);
  return { preset, setPreset, from, setFrom, to, setTo, params };
}
